import { render } from "./createTemplate.vue?vue&type=template&id=2fc1b775&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"

import "./createTemplate.vue?vue&type=style&index=0&id=2fc1b775&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc1b775"]])

export default __exports__